

import { useTranslation } from 'react-i18next';
import {useConfig} from "../helpers/useConfig";
import { c_or_f } from '../helpers/Utils';
const ForecastHour = (props) => {
    const {configData, setConfig} = useConfig();
    
    function checkIsSigHour () {
        var found = false;
        props.sigHours.forEach((hour) => {  if (hour.time == props.time) found = true;})
        return found;
    }
    function getWindHeight () {
        return 80;
        if (props.isTemp) 
        {
           return (props.tempPercent > 15) ? props.tempPercent-6 : 10;
        }
        else
        if (props.isRainrate)
        {
            return (props.rain > 25) ? props.rain-15 : 15;
        } 
        else
            return 15;

    }
    function getClothBottom () {
        if (props.isTemp) 
        {
           return (props.tempPercent > 15) ? props.tempPercent-9 : 5;
        }
        else
        if (props.isRainrate)
        {
            return (props.rain > 25) ? props.rain-15 : 15;
        } 
        else
            return 15;

    }

    function getMarginTopClass(icon){
        if (icon.indexOf('rain') > -1)
            return '';
        if (icon.indexOf('showers') > -1)
            return '';
        if (icon.indexOf('partlycloudy') > -1)
            return 'pc2';
        return 'pc';

    }

    function getRainDesc(rainrate){
        if (rainrate <= 30)
            return t('RAIN_LOW_EXP');
        else if (rainrate <= 60)
            return t('RAIN_GOOD_EXP');
        else
            return t('RAIN_HIGH_EXP');
    }
    
    const { t } = useTranslation();
    let day_title = (props.lang == 1) ? props.day1 : props.day0;
    let wind_title = (props.lang == 1) ? props.wind_title1 : props.wind_title0;
    let cloth_title = (props.lang == 1) ? props.cloth_title1 : props.cloth_title0;
    let wind_height = getWindHeight();
    let cloth_height = getClothBottom();
    let rain_height = props.rain < 15  ? props.rain : props.rain - 10;
    var isSigHour = checkIsSigHour();
    let rainrate_exp = getRainDesc(props.rain);
        
    return (
        <li className={"x-axis-bar-item " + " " + (props.vertical === true ? "vertical": "")}>
            <div className="x-axis-bar-item-container" >
                <div className="x-axis-bar primary">{props.time % 3 === 0 ? day_title : ''} {props.time}:00</div>
                <div className={" x-axis-bar tertiary icon " + (getMarginTopClass(props.icon))} >
                <div className={" span-value " + ((props.lang == 1) ? 'rtl' : '')} data-value={`${c_or_f(props.temp, configData.tempUnit)}° \n  ${props.wind} ${t('KMH')}`}>
                   <img src={`https://v2013.02ws.co.il/images/icons/day/${props.icon}`} height="40" width="40" alt="" />
                </div>
                </div>
                {props.isTemp &&
                    <div className="x-axis-bar secondaryalt temp" style={{ height: `${props.tempPercent}%` }}>
                     <div className={"span-value temp-value"} data-value={`${c_or_f(props.temp, configData.tempUnit)}° \n  ${props.wind} ${t('KMH')}`}>{c_or_f(props.temp, configData.tempUnit)}<div className="paramunit">°</div></div>
                    </div>
                }
                
                {props.isCloth &&
                    <div className="x-axis-bar tertiary cloth " style={{ bottom: `${cloth_height}%` }}>
                        <span className={"span-value " + ((props.lang == 1) ? 'rtl' : '')} data-value={cloth_title} >
                        <img  src={`https://v2013.02ws.co.il/${props.cloth}`} height="28" width="28" alt="" />
                        </span>
                    </div>
                    
                }
                {props.isHumidity && 
                    <div className="x-axis-bar tertiary humidity" >
                        <span className="span-value" data-value="לחות">{props.hum}%</span>
                    </div>
                }
                {props.isRainrate && 
                    <div className="x-axis-bar tertiary rainchance" style={{ height: `${rain_height}%` }}>
                        <span className="span-value" data-value={rainrate_exp}>{props.rain}%</span>
                    </div>
                }
                {(isSigHour || props.isWind) &&
                    <div className="x-axis-bar tertiary wind " style={{ bottom: `${wind_height}%` }}>
                        <div className="wind-overlay">
                       <div title={wind_title} className={"wind_icon " + props.wind_class}></div>
                        </div>
                    </div>
                    
                }
                {(isSigHour ) && 
                    <div className="x-axis-bar tertiary text" >
                        {eval(`props.title${props.lang}`)}
                    </div>
                }
                
            </div>
        </li>
      );
}

export default ForecastHour; 